import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render( // 👈️ deprecated starting React 18
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

